import {
	Checkbox,
	Dialog,
	DialogContent,
	type DialogProps,
	FormControlLabel,
	Grid,
	TextField,
	Typography,
	makeStyles,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useAssetContext } from "../../../../../context/assetContext";
import { useConfigurationAssetContext } from "../../context/ConfigurationAssetContext";
import { AssetAPI } from "../../models/AssetAPI";
import { DATA_ASSET_INITIAL_VALUES } from "../../models/InitialValueDataAsset";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .input-group-text": {
			display: "none",
		},
		"& .MuiPaper-root": {
			height: "auto",
		},
		"& .MuiDialogContent-dividers": {
			borderBottom: "unset",
		},
	},
	customDialog: {
		"& .MuiDivider-root:last-child": {
			display: "none",
		},
	},
	checkbox: {
		userSelect: "none",
	},
	modalTitle: {
		backgroundColor: "#ced2cc",
		color: "#495057",
		textAlign: "center",
	},
	modalTitleCloseWO: {
		backgroundColor: "#28a745",
		color: "white",
		textAlign: "center",
	},
	modalWarning: {
		color: "white",
		backgroundColor: "#dc3545",
		textAlign: "center",
	},
	messageTitle: {
		fontSize: 15,
		fontWeight: "bold",
		color: "#0000008A",
	},
	formControl: {
		margin: theme.spacing(2),
		minWidth: 120,
	},
	errorLabel: {
		fontSize: 12,
		color: "#F44336",
	},
}));

type Props = {
	show: boolean;
	onHide: (onHide: boolean) => void;
};

export const ViewerAssetDialog = ({ show, onHide }: Props) => {
	const classes = useStyles();
	const [fullWidth, setFullWidth] = useState(true);
	const [maxWidth, setMaxWidth] = useState<DialogProps["maxWidth"]>("sm");

	const {
		state: { dataToCreateAsset, assetNodeSelectedInTree },
	} = useConfigurationAssetContext();

	const {
		state: { allAssets },
	} = useAssetContext();

	const {
		control,
		reset,
		setValue,
		formState: { errors },
	} = useForm<AssetAPI>({
		defaultValues: dataToCreateAsset
			? dataToCreateAsset
			: DATA_ASSET_INITIAL_VALUES,
	});

	const handleCancel = () => {
		onHide(false);
	};

	useEffect(() => {
		if (show) {
			reset();
			setValue("ParentAssetId", assetNodeSelectedInTree?.ParentAssetId);
			const parentAssetNode = allAssets.find(
				(node: any) => node.AssetId === assetNodeSelectedInTree?.ParentAssetId,
			);
			setValue("AssetName", assetNodeSelectedInTree?.AssetName);
			setValue("ParentAssetName", parentAssetNode?.AssetName as string);
			setValue("IsBranch", assetNodeSelectedInTree?.IsBranch);
			const assetNodeFromApi = allAssets.find(
				(node: any) => node.AssetId === assetNodeSelectedInTree?.AssetId,
			);
			setValue(
				"CanBeDefaultAsset",
				assetNodeFromApi?.CanBeDefaultAsset as boolean,
			);
		}
	}, [show]);

	return (
		<div className={classes.root}>
			<Dialog
				fullWidth={fullWidth}
				maxWidth={maxWidth}
				open={show}
				onClose={() => handleCancel()}
				disableEnforceFocus
				className={classes.root}
			>
				<form onSubmit={() => {}}>
					<Grid container style={{ padding: "15px 0", height: "50%" }}>
						<Grid container item>
							<Grid item md={12} xs={12}>
								<Typography style={{ padding: "0 24px 12px", fontSize: 25 }}>
									{assetNodeSelectedInTree?.AssetName}
								</Typography>
							</Grid>
						</Grid>
						<Grid container style={{ alignItems: "center" }}>
							<DialogContent dividers style={{ padding: "10px 24px 0" }}>
								<Grid item md={12} xs={12}>
									<Controller
										name="AssetName"
										control={control}
										render={({ field: { onChange, value } }) => (
											<>
												<TextField
													label="Asset Name"
													variant="outlined"
													error={!!errors.AssetName}
													fullWidth
													margin="dense"
													autoComplete="off"
													onChange={onChange}
													value={value}
													disabled={true}
												/>
											</>
										)}
									/>
								</Grid>
								<Grid container>
									<Grid item md={12} xs={12} style={{ marginBottom: "8px" }}>
										<Grid
											item
											md={12}
											xs={12}
											style={{ padding: 0, marginTop: 10 }}
										>
											<Controller
												name="ParentAssetName"
												control={control}
												render={({ field: { onChange, value } }) => (
													<>
														{value ? (
															<TextField
																label={"Parent Asset"}
																variant="outlined"
																error={!!errors.AssetName}
																fullWidth
																margin="dense"
																autoComplete="off"
																onChange={onChange}
																value={value || ""}
																disabled={true}
															/>
														) : (
															<></>
														)}
													</>
												)}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										style={{ marginTop: "5px", padding: "0 8px" }}
									>
										<Grid item xs={6} md={6}>
											<Controller
												name="IsBranch"
												control={control}
												defaultValue={false}
												render={({ field }) => (
													<FormControlLabel
														className={classes.checkbox}
														control={
															<Checkbox
																checked={field.value as boolean}
																onChange={(e) =>
																	field.onChange(e.target.checked)
																}
																name="IsBranch"
																color="primary"
																disabled={true}
															/>
														}
														label="Has Children"
													/>
												)}
											/>
										</Grid>
										<Grid item xs={6} md={6}>
											<Controller
												name="CanBeDefaultAsset"
												control={control}
												defaultValue={false}
												render={({ field }) => (
													<FormControlLabel
														className={classes.checkbox}
														control={
															<Checkbox
																checked={field.value as boolean}
																onChange={(e) =>
																	field.onChange(e.target.checked)
																}
																name="CanBeDefaultAsset"
																color="primary"
																disabled={true}
															/>
														}
														label="Can be Default Asset"
													/>
												)}
											/>
										</Grid>
									</Grid>
								</Grid>
							</DialogContent>
						</Grid>
					</Grid>
				</form>
			</Dialog>
		</div>
	);
};
